var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[(this.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!this.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('layout-tabbar',{attrs:{"active-color":"#DB1905","tab-list":_vm.tabbarList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }